
import { defineComponent } from '@nuxtjs/composition-api';
import WarRoomJobApplicationMixin from '@/components/partials/war-room/WarRoomJobApplicationBanner/WarRoomJobApplicationMixin';
import Footer from '@/components/global/Footer/Footer.vue';
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

export default defineComponent({
  name: 'LayoutDefault',
  components: {
    HeaderMenuNotifications: () =>
      import('@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotifications.vue'),
    // We include footer component without async, otherwise styles of footer will be loaded in external chunk,
    // but in prune mode (for crawler) it wouldn't and footer won't have styles at all
    GlobalFooter: Footer,
  },
  mixins: [defaultLayoutMixin, WarRoomJobApplicationMixin],
});
